var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"href":"https://fonts.googleapis.com/icon?family=Material+Icons","rel":"stylesheet"}}),_c('router-view',{attrs:{"id":"menu-view","name":"menu"}}),_c('router-view',{attrs:{"id":"main-view","name":"main"}}),_c('Snackbar',{attrs:{"id":"snackbarPosition"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }